import { useCallback } from "react";

import useFast from "@/src/contexts/FASTContext";
import { getMediaColorByFormat } from "@/src/utils/fast";

import useDefaultMediaColor from "./useDefaultMediaColor";

import type { MediaFormatWithAdBreak } from "@/src/constants/media";

export default function useMediaColorByFormat(): (
  format?: MediaFormatWithAdBreak | null,
) => string {
  const { state } = useFast();
  const mediasColor = state.channelData?.medias_colors;
  const defaultMediaColor = useDefaultMediaColor();

  return useCallback(
    (format?: MediaFormatWithAdBreak | null): string =>
      getMediaColorByFormat(format, mediasColor, defaultMediaColor),
    [mediasColor, defaultMediaColor],
  );
}
